type ObjectWithOptions = {
  namespace: string
  obj: Record<string, any>
  formData?: FormData
}

export const toSnakeCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2') // Insert _ between camelCase words
    .replace(/\s+/g, '_') // Replace spaces with _
    .toLowerCase()
}

export const objectToFormData = ({
  namespace,
  obj,
  formData = new FormData(),
}: ObjectWithOptions): FormData => {
  Object.entries(obj).forEach(([key, value]) => {
    const formKey = namespace
      ? `${toSnakeCase(namespace)}[${toSnakeCase(key)}]`
      : key

    if (value instanceof Date) {
      // Handle dates properly
      formData.append(formKey, value.toISOString())
    } else if (value instanceof File) {
      // Handle file uploads
      formData.append(formKey, value)
    } else if (Array.isArray(value)) {
      // Handle arrays (e.g., nested attributes)
      value.forEach((element, index) => {
        objectToFormData({
          obj: element,
          formData,
          namespace: `${formKey}[${index}]`,
        })
      })
    } else if (typeof value === 'object' && value !== null) {
      // Handle nested objects
      objectToFormData({ obj: value, formData, namespace: formKey })
    } else {
      if (value === null || value === undefined || value === '') {
        return // skip truly empty values but keep boolean false and 0
      }
      // Handle primitive values
      formData.append(formKey, value.toString())
    }
  })

  return formData
}
